var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.8327 14.1667C9.91602 14.1667 9.16602 13.4167 9.16602 12.5V7.5C9.16602 6.58333 9.91602 5.83333 10.8327 5.83333H15.8327V4.16666H4.16602V15.8333H15.8327V14.1667H10.8327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.06667V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V13.9333C17.9917 13.6417 18.3333 13.1167 18.3333 12.5V7.5C18.3333 6.88333 17.9917 6.35 17.5 6.06667ZM16.6667 7.5V12.5H10.8333V7.5H16.6667ZM4.16667 15.8333V4.16667H15.8333V5.83333H10.8333C9.91667 5.83333 9.16667 6.58333 9.16667 7.5V12.5C9.16667 13.4167 9.91667 14.1667 10.8333 14.1667H15.8333V15.8333H4.16667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 11.25C14.0243 11.25 14.584 10.6904 14.584 10C14.584 9.30964 14.0243 8.75 13.334 8.75C12.6436 8.75 12.084 9.30964 12.084 10C12.084 10.6904 12.6436 11.25 13.334 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopup);
export default __webpack_public_path__ + "static/media/topup.4784b6e4.svg";
export { ForwardRef as ReactComponent };